module.exports = __webpack_public_path__ + "img/pagi-large.e40c92ee.png";